export enum TypeSanctionStructureType {
    STAGGERED = 1001, // Multa escalonada
    NO_ARRIVE_CHECKPOINT = 1002, // Multa por no llegar al punto
    FIXED = 1003 // Multa Fija
}